import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';
import selectorStateComparison from 'Redux/utilities/selectorStateComparison';
import Icon from 'ViatoUi/Shared/DataDisplay/Icon';
import UserActionFeedback from 'ViatoUi/Shared/Feedback/UserActionFeedback';
import { FlexBox } from 'ViatoUi/Shared/Layouts/Flex';

import CopyLink from './Modals/CopyLink';
import CreateLink from './Modals/CreateLink';
import styles from './Share.module.scss';

const Share = () => {
	const { t } = useTranslation('contractGenerator');

	const [showSavePopup, setShowSavePopup] = useState(false);
	const [showSessionPopup, setShowSessionPopup] = useState(false);

	const [saveCallPending, saveCallError, saveCallErrorCode, saveCallErrorMessage] = useSelector(
		contractGeneratorSelectors.getSaveSessionApiCall(),
		(formerState, currentState) => selectorStateComparison(formerState, currentState)
	);

	const errorMessage = useMemo(() => {
		switch (saveCallErrorCode) {
			case 509:
				return t('layouts.share.errorMessages.509');
			case 510:
				return t('layouts.share.errorMessages.510');
			case 511:
				return t('layouts.share.errorMessages.511');
			case 512:
				return t('layouts.share.errorMessages.512');
			case 514:
				return t('layouts.share.errorMessages.514');
			default:
				return t('layouts.share.errorMessages.unknown');
		}
	}, [saveCallErrorCode]);

	return (
		<>
			<FlexBox
				alignItems='center'
				className={styles.share}
				justifyContent='center'
				tooltip={t('layouts.share.tooltip')}
				onClick={() => setShowSavePopup(true)}
			>
				<Icon className={styles.icon} color='bright' icon='fa-paper-plane' iconWeight='fas' size='xxl' />
			</FlexBox>
			<CreateLink visible={showSavePopup} onClose={() => setShowSavePopup(false)} />
			<CopyLink visible={showSessionPopup} onClose={() => setShowSessionPopup(false)} />
			<UserActionFeedback
				error={!!saveCallError}
				errorCode={saveCallErrorCode}
				errorMessage={saveCallErrorMessage}
				pending={!!saveCallPending}
				type='modal'
				userMessage={errorMessage}
				isSilent
				onSuccess={() => setShowSessionPopup(true)}
			/>
		</>
	);
};

export default Share;
